/*
 * Foreign VAT on a receipt from abroad — the hotel in Paris, the taxi in
 * Stockholm. A supplier abroad selling to a business under the EU or
 * reverse-charge rules invoices WITHOUT VAT, so VAT on its receipt is that
 * country's own, charged locally: never deductible at home. The line takes the
 * local-VAT code (DK K710 "Køb med lokal moms", one per country, scheme
 * localVat): 0 % here, the whole amount cost.
 *
 * A rule, not a choice between codes at the receipt's rate: that rate is
 * foreign — 10 % has no Danish code at all, and a Swedish 25 % would wrongly
 * match the Danish EU-acquisition codes.
 *
 * Not when the supplier's VAT number is from the org's own country: a foreign
 * company registered here charges this country's VAT, and the ordinary codes
 * apply.
 *
 * One rule for both sides: the classifier, when a receipt is read
 * (server/src/services/classify), and Apply, for a receipt read before the
 * rule existed (client/src/components/documents/applyExtraction.js).
 *
 *   list             the VAT picker's list (GET vatTax): { data: [codes] }
 *   vatRate          the line's rate as printed on the receipt (0.1)
 *   supplierCountry  where the supplier is (ISO 2)
 *   orgCountry       the org's own country (ISO 2)
 *   taxId            the supplier's VAT number, as printed or stored
 *
 * Returns the local-VAT code from the list, or null.
 */
export const isLocalVatCode = (code) => code?.scope === 'purchases' && code?.scheme === 'localVat'

export const foreignVatCode = (list, { vatRate, supplierCountry, orgCountry, taxId } = {}) => {
    if (!(typeof vatRate === 'number' && vatRate > 0)) return null
    if (!supplierCountry || !orgCountry || supplierCountry === orgCountry) return null
    const vatNumber = String(taxId ?? '').replace(/[^A-Za-z0-9]/g, '').toUpperCase()
    if (vatNumber.startsWith(orgCountry.toUpperCase())) return null
    return (list?.data || []).find(isLocalVatCode) ?? null
}

export default foreignVatCode
